import React from 'react';
import styles from "../Footer.module.scss"

const Footer2 = () => {
    return (
        <>
        <div className={styles.wrapper}>
        <div className={styles.container2}>
          <div className={styles.left}>
           <div className={styles.heading}>@2021, Hogi PAY. All rights reserved</div>
          </div>

          <div className={styles.rightmenu}>         
          <img src="/assets/Icon-World.png"/>
          <div class="select">
          <select>
              <option value="1">Language</option>
              <option value="2">No JS</option>
              <option value="3">Nice!</option>
          </select>
          </div>
          <img src="/assets/Arrow.png" className={styles.img2}/>
          </div>
          
          </div>
          </div>
        </>
    )
}

export default Footer2
